module.exports = __webpack_public_path__ + "static/media/signage-indoor-img40.49c2cec3.jpg";